import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { InfiniteScroll } from "../../components";
import { EndPoints } from "../../Constants/endpoints";
import { useGetData } from "../../hooks";
import { INotification } from "../../interface/GeneralResponse";
import { INotificationTypesResponseData } from "../../interface/notification";
import { NotificationsLoader } from "../../Share";
import { NotificationItem } from "./NotificationItem";

const NotificationPage = () => {
  const [notificationsData, setNotificationsData] = useState<INotification[]>();

  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const currentLocationParams = new URLSearchParams(location.search);
  const currentFilters =
    currentLocationParams.get("filter") != "ALL"
      ? currentLocationParams.get("filter")
      : undefined;

  const { data: notificationsTypesData } = useGetData<
    INotificationTypesResponseData[]
  >(EndPoints.NotificationsTypes);

  const notificationsTypes = [
    { Name: t("all_notifications"), Code: "ALL" },
    ...(notificationsTypesData?.Data ?? []),
  ];

  return (
    <div className="flex flex-col items-start justify-start gap-2 self-stretch rounded-lg bg-white p-4 lg:p-6">
      <div className="flex w-full justify-between">
        <div className="text-primary-text mb-2 pt-2.5 text-base font-bold leading-relaxed">
          {t("notifications")}
        </div>
      </div>
      <div className={`flex max-w-full gap-2 overflow-auto pb-6 lg:gap-0`}>
        {notificationsTypes?.map((item, index: number) => {
          const isSelectedStatus = currentFilters
            ? currentFilters == item?.Code
            : item?.Code == "ALL";
          return (
            <div
              key={index}
              className={`nav-link cursor-pointer text-nowrap p-2 text-center lg:min-w-[8rem] lg:text-lg ${isSelectedStatus ? "active font-bold" : "text-text-muted"}`}
              onClick={() => {
                currentLocationParams.set("filter", item?.Code);
                const queryString = currentLocationParams.toString();
                navigate(`?${queryString}`);
              }}
            >
              {item?.Name}
            </div>
          );
        })}
      </div>

      <div className="mb-4 flex h-[60dvh] w-full flex-col gap-6 overflow-auto pb-4 max-md:h-[65dvh]">
        {notificationsData?.map((item: INotification, index: number) => {
          return <NotificationItem key={index} item={item} />;
        })}
        <InfiniteScroll
          Count={12}
          skeletonCount={1}
          extraDataKey="Notifications"
          endpoint={EndPoints.Notifications}
          getAllParams={
            currentFilters
              ? {
                  Types: currentFilters,
                }
              : undefined
          }
          getData={(data) => setNotificationsData(data)}
          renderSkeleton={<NotificationsLoader />}
        />
      </div>
    </div>
  );
};
export default NotificationPage;
